import { parsePhoneNumberWithError, isValidPhoneNumber } from 'libphonenumber-js';

export function processPhoneWithLibrary(phone: string): {
    phone: string;
    formattedPhone: string;
    e164Phone: string;
    countryCode: string;
} {
    try {
        const digits = phone.replace(/\D/g, '');

        if (digits.length < 10) {
            return {
                phone: phone,
                formattedPhone: phone,
                e164Phone: phone,
                countryCode: 'PARTIAL'
            };
        }

        let phoneToParseE164: string;

        if (digits.length === 10) {
            phoneToParseE164 = `+1${digits}`;
        } else if (digits.length === 11 && digits.startsWith('1')) {
            phoneToParseE164 = `+${digits}`;
        } else {
            phoneToParseE164 = `+${digits}`;
        }

        const phoneNumber = parsePhoneNumberWithError(phoneToParseE164);

        if (phoneNumber && phoneNumber.isValid()) {
            return {
                phone: phoneNumber.formatNational(),
                formattedPhone: phoneNumber.formatInternational(),
                e164Phone: phoneNumber.format('E.164'),
                countryCode: phoneNumber.country || 'UNKNOWN'
            };
        } else {
            if (digits.length === 10) {
                const areaCode = digits.slice(0, 3);
                const exchange = digits.slice(3, 6);
                const number = digits.slice(6);

                return {
                    phone: `(${areaCode}) ${exchange}-${number}`,
                    formattedPhone: `+1 ${areaCode} ${exchange} ${number}`,
                    e164Phone: `+1${digits}`,
                    countryCode: 'US'
                };
            } else {
                return {
                    phone: phone,
                    formattedPhone: `+${digits}`,
                    e164Phone: `+${digits}`,
                    countryCode: 'UNKNOWN'
                };
            }
        }
    } catch {
        const digits = phone.replace(/\D/g, '');

        if (digits.length < 10) {
            return {
                phone: phone,
                formattedPhone: phone,
                e164Phone: phone,
                countryCode: 'PARTIAL'
            };
        }

        if (digits.length === 10) {
            const areaCode = digits.slice(0, 3);
            const exchange = digits.slice(3, 6);
            const number = digits.slice(6);

            return {
                phone: `(${areaCode}) ${exchange}-${number}`,
                formattedPhone: `+1 ${areaCode} ${exchange} ${number}`,
                e164Phone: `+1${digits}`,
                countryCode: 'US'
            };
        } else if (digits.length === 11 && digits.startsWith('1')) {
            const phoneDigits = digits.slice(1);
            const areaCode = phoneDigits.slice(0, 3);
            const exchange = phoneDigits.slice(3, 6);
            const number = phoneDigits.slice(6);

            return {
                phone: `(${areaCode}) ${exchange}-${number}`,
                formattedPhone: `+1 ${areaCode} ${exchange} ${number}`,
                e164Phone: `+${digits}`,
                countryCode: 'US'
            };
        } else if (digits.length >= 10) {
            return {
                phone: phone,
                formattedPhone: phone.startsWith('+') ? phone : `+${digits}`,
                e164Phone: phone.startsWith('+') ? phone : `+${digits}`,
                countryCode: 'UNKNOWN'
            };
        }

        return {
            phone: phone,
            formattedPhone: phone,
            e164Phone: phone,
            countryCode: 'INVALID'
        };
    }
}

export function isValidPhone(phone: string): boolean {
    if (!phone) return false;

    const digits = phone.replace(/\D/g, '');

    if (digits.length < 10) return false;

    try {
        if (digits.length === 10) {
            return isValidPhoneNumber(`+1${digits}`);
        }

        if (digits.length === 11 && digits.startsWith('1')) {
            return isValidPhoneNumber(`+${digits}`);
        }

        return isValidPhoneNumber(`+${digits}`);
    } catch {
        return false;
    }
}
